import React, { useEffect } from 'react';

export function CinematicBackground() {
  useEffect(() => {
    const handleScroll = () => {
      const iframe = document.getElementById('peach-iframe');
      if (iframe && iframe.contentWindow) {
        // The PeachWeb export contains a full landing page with multiple sections.
        // We only want to play the first section's smooth 3D animation.
        // We calculate the user's scroll progress (0 to 1) and map it strictly 
        // to the safe zone (0 to 1200 pixels) of the iframe's animation.
        const maxPageScroll = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
        const scrollProgress = Math.max(0, Math.min(1, window.scrollY / maxPageScroll));
        
        const safeScrollY = scrollProgress * 1200;
        iframe.contentWindow.postMessage({ type: 'scroll', scrollY: safeScrollY }, '*');
      }
    };
    
    const handleMouseMove = (e) => {
      const iframe = document.getElementById('peach-iframe');
      if (iframe && iframe.contentWindow) {
        iframe.contentWindow.postMessage({ type: 'mousemove', clientX: e.clientX, clientY: e.clientY }, '*');
      }
    };
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('mousemove', handleMouseMove, { passive: true });
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <iframe 
      id="peach-iframe"
      src="/peachbg.html" 
      title="Cinematic Background"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        zIndex: -1,
        border: 'none',
        pointerEvents: 'auto',
        backgroundColor: '#03021b',
      }}
    />
  );
}
